<template>
    <div class="menu-slide-left">
        <el-menu
            :default-active="active"
            class="el-menu-vertical-demo"
            router>
                <el-menu-item index="/homePage" >
                    <i class="pre-icon">
                        <img src="../assets/slider/home.png" alt="">
                    </i>
                    <span class="m-title">首页</span>
                </el-menu-item>
                <el-submenu index="1">
                    <template slot="title">
                        <i class="pre-icon">
                            <img src="../assets/slider/site.png" alt="">
                        </i>
                        <span class="m-title">检车业务</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/">
                            拍照上传
                        </el-menu-item>
                        <el-menu-item index="/check-query">
                            报告查询
                        </el-menu-item>
                        <el-menu-item index="/verify">
                            报告审核
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="2">
                    <template slot="title">
                        <i class="pre-icon">
                            <img src="../assets/slider/edit.png" alt="">
                        </i>
                        <span class="m-title">检测站管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/">
                            站查询
                        </el-menu-item>
                        <el-menu-item index="/">
                            新增站
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="3">
                    <template slot="title">
                        <i class="pre-icon">
                            <img src="../assets/slider/money.png" alt="">
                        </i>
                        <span class="m-title">费用管理中心</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/my-account">
                            我的账单
                        </el-menu-item>
                        <el-menu-item index="/check-account">
                            账单对账
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="4">
                    <template slot="title">
                        <i class="pre-icon">
                            <img src="../assets/slider/report.png" alt="">
                        </i>
                        <span class="m-title">检车报表</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/">
                            平台报表
                        </el-menu-item>
                        <el-menu-item index="/">
                            监控台
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="5">
                    <template slot="title">
                        <i class="pre-icon">
                            <img src="../assets/slider/setting.png" alt="">
                        </i>
                        <span class="m-title">系统设置</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/user-manager">
                            账号管理
                        </el-menu-item>
                        <el-menu-item index="/">
                            权限管理
                        </el-menu-item>
                        <el-menu-item index="/">
                            常用管理
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="6">
                    <template slot="title">
                        <i class="pre-icon">
                             <img src="../assets/slider/message.png" alt="">
                        </i>
                        <span class="m-title">通知公告</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/">
                            公告查看
                        </el-menu-item>
                        <el-menu-item index="/">
                            公告管理
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-menu-item index="/user-manager" >
                    <i class="pre-icon">
                         <img src="../assets/slider/add.png" alt="">
                    </i>
                    <span slot="title" class="m-title">用户新增站</span>
                </el-menu-item>
                
                
            </el-menu>
    </div>
</template>

<script>
    export default {
        props:['active'],
        methods: {
            
        },
    }
</script>

<style scoped>
 .m-title{
     font-size: 16px
 }
 .pre-icon img{
    width: 20px;
    margin-right: 10px;
    position: relative;
    top: -3px;
 }

</style>